import React, { useEffect, useState } from "react";
import { createColumnHelper } from "@tanstack/react-table";
import SlideOutSidebar from "../../ui-components/slide-out-sidebar/slideOutSidebar";
import Table from "../../ui-components/table/table";
import PaymentService from "../../app/data/payment/paymentService";
import { PaymentUiSettingChangeLogEntry } from "../../app/data/payment/PaymentSession";

const paymentService = PaymentService.getInstance();
const columnHelper = createColumnHelper<PaymentUiSettingChangeLogEntry>();

const SETTING_LABELS: Record<string, string> = {
  cc_surcharge_warning_message: "Surcharge warning",
  cc_surcharge_enabled: "CC surcharge",
  ach_bank_details: "ACH bank details",
};

const getSettingLabel = (settingKey: string): string => {
  if (settingKey.startsWith("cc_surcharge_waiver:")) {
    return "Account surcharge waiver";
  }
  return SETTING_LABELS[settingKey] || settingKey;
};

const getTableColumns = () => [
  columnHelper.accessor("dateCreated", {
    id: "dateCreated",
    header: "Timestamp",
    cell: (cellProps) => {
      const value = cellProps.getValue() as string | undefined;
      return <>{value ? value.toUiDateTimeFormat?.() ?? value : "—"}</>;
    },
    size: 180,
  }),
  columnHelper.accessor("settingKey", {
    id: "settingKey",
    header: "Setting",
    cell: (cellProps) => (
      <>{getSettingLabel(cellProps.getValue())}</>
    ),
    size: 160,
  }),
  columnHelper.accessor("changeDescription", {
    id: "changeDescription",
    header: "Change",
    cell: (cellProps) => (
      <span title={cellProps.getValue()}>{cellProps.getValue()}</span>
    ),
    size: 320,
  }),
  columnHelper.accessor("userCreated", {
    id: "userCreated",
    header: "Performed by",
    size: 200,
  }),
];

export interface PaymentSettingsChangeLogProps {
  show: boolean;
  onClose: () => void;
}

const PaymentSettingsChangeLog: React.FC<PaymentSettingsChangeLogProps> = (props) => {
  const [logs, setLogs] = useState<PaymentUiSettingChangeLogEntry[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!props.show) {
      return;
    }
    setLoading(true);
    paymentService.getPaymentSettingsChangeLog().then((res) => {
      if (res.ok()) {
        setLogs(res.data || []);
      } else {
        setLogs([]);
      }
      setLoading(false);
    });
  }, [props.show]);

  return (
    <SlideOutSidebar
      onClose={props.onClose}
      spinner={loading}
      show={props.show}
      header="Payment settings change log"
    >
      <div className="xgs-payment-settings__logs">
        <div className="xgs-payment-settings__logs-heading">Recent changes</div>
        <Table infiniteScroll columns={getTableColumns()} data={logs} />
      </div>
    </SlideOutSidebar>
  );
};

export default PaymentSettingsChangeLog;
